import { ImagenPublica } from './propiedad.model';

/** Sección del portal donde puede mostrarse un banner (`GET /publico/banners`). */
export enum TipoBanner {
  WEB_SUPERIOR = 'web_superior',
  WEB_INFERIOR = 'web_inferior',
  HOME_USUARIO = 'home_usuario',
}

/**
 * Banner publicitario activo de una sección (spec §17). Sin copy propio: el
 * arte (imagen desktop + mobile) lo carga el anunciante desde el backoffice.
 * Las secciones sin banner cargado no vienen en la respuesta del endpoint.
 */
export interface Banner {
  id: string;
  tipo: TipoBanner;
  /** Destino del click. `null` = banner no clickeable. */
  link: string | null;
  imagenDesktop: ImagenPublica;
  imagenMobile: ImagenPublica;
}
